import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import Button from '../../common/Button';

const AMC = () => {
  return (
    <section className="pt-24 pb-16 bg-white">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <SectionHeading
              title="Annual Maintenance Contract (AMC)"
              subtitle="Comprehensive maintenance services for your IT infrastructure."
            />
            
            <p className="text-gray-600 mb-6">
              Our Annual Maintenance Contract (AMC) services provide businesses with proactive and comprehensive 
              support for their IT infrastructure. By choosing our AMC, you gain access to regular maintenance, 
              priority support, and expert technical assistance that ensures your systems operate at peak 
              performance throughout the year.
            </p>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 flex items-center justify-center text-white font-bold mr-3 flex-shrink-0 mt-0.5">✓</div>
                <div>
                  <span className="font-semibold text-gray-800">Preventive Maintenance:</span>
                  <span className="text-gray-600"> Regular system checks and optimization to prevent issues before they occur.</span>
                </div>
              </li>
              
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 flex items-center justify-center text-white font-bold mr-3 flex-shrink-0 mt-0.5">✓</div>
                <div>
                  <span className="font-semibold text-gray-800">Priority Response:</span>
                  <span className="text-gray-600"> Expedited support for critical issues to minimize downtime.</span>
                </div>
              </li>
              
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 flex items-center justify-center text-white font-bold mr-3 flex-shrink-0 mt-0.5">✓</div>
                <div>
                  <span className="font-semibold text-gray-800">Regular Reporting:</span>
                  <span className="text-gray-600"> Detailed insights into system performance and maintenance activities.</span>
                </div>
              </li>
              
              <li className="flex items-start">
                <div className="h-6 w-6 rounded-full bg-green-500 flex items-center justify-center text-white font-bold mr-3 flex-shrink-0 mt-0.5">✓</div>
                <div>
                  <span className="font-semibold text-gray-800">Cost Predictability:</span>
                  <span className="text-gray-600"> Fixed annual fee that helps in budget planning and cost control.</span>
                </div>
              </li>
            </ul>
            
            <Button to="/contact" variant="primary">
              Get AMC Details
            </Button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 shadow-md">
              <h3 className="text-xl font-bold mb-4 text-gray-800">Why Choose Our AMC?</h3>
              
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2">Proactive Approach</h4>
                  <p className="text-gray-600 text-sm">
                    Instead of waiting for problems to occur, we take a proactive approach to maintenance, 
                    identifying and addressing potential issues before they impact your operations.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2">Experienced Technicians</h4>
                  <p className="text-gray-600 text-sm">
                    Our maintenance services are delivered by experienced technicians with extensive knowledge 
                    of various hardware platforms and IT systems.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2">Flexible Plans</h4>
                  <p className="text-gray-600 text-sm">
                    We offer flexible AMC plans that can be tailored to your specific requirements and budget, 
                    ensuring you get the right level of support for your business.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2">Comprehensive Coverage</h4>
                  <p className="text-gray-600 text-sm">
                    Our AMC covers a wide range of hardware and software components, providing you with 
                    comprehensive protection for your entire IT infrastructure.
                  </p>
                </div>
              </div>
              
              <div className="mt-8 p-4 bg-blue-50 border border-blue-100 rounded-md">
                <p className="text-blue-800 text-sm italic">
                  "The AMC from Bytematic has been invaluable for our business. Their proactive maintenance 
                  has significantly reduced our system downtime and improved overall performance."
                </p>
                <p className="text-right text-blue-600 text-sm mt-2">- A Satisfied Client</p>
              </div>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default AMC;